import { AxiosInstance } from 'axios';

class FolderService {
  constructor(private ApiClient: AxiosInstance) {}

  create = async (params: { name: string; event_id?: string }) => {
    const { data } = await this.ApiClient.post('/folders', params);
    return data;
  };

  list = async () => {
    const { data } = await this.ApiClient.get('/folders');
    return data;
  };

  update = async (params: { id: string; name: string }) => {
    const { data } = await this.ApiClient.put('/folders', params);
    return data;
  };

  delete = async (params: { id: string }) => {
    const { data } = await this.ApiClient.delete('/folders', { params });
    return data;
  };
}

export default FolderService;
